<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>
      制作习题
      <span>></span>
      大题列表
      <span>></span>
      小题列表
      <span>></span>
      编辑首字母填空题
    </div>
    <div class="student_test">
      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">制作习题</div>
            <div class="xiaoqu_2">
            </div>
          </div>
          <p class="tishi">
            <i>
              <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
            </i> 功能前方标注红色星号的属于必填内容，未标星号的是选填内容可进行自由填写，不同功能的备注事宜写在功能后方
          </p>
          <div class="form_1">
            <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
              <el-form-item label="习题范例" prop="desc" v-show="show">
                <div class="xtfl1">
                  <h3>原文</h3>
                  <h3> When I was walking down the street the other day, I happened to D__ a small brown purse D__ on the road. I L__ it up and opened it to see if I could
                     A__the owner's name. There was W_inside it R__some changes (零钱) and an old photo--a picture of a woman and a young girl of about twelve years old who looked
                     C__ the woman's daughter. I put the photo back and I_the purse to police station, S__I handed it to an officer. Before I left, the officer took my name and address
                     Z__the owner might want to write and thank me.
                  </h3>
                  <el-button @click="show=false" v-show="show" type="primary">收起</el-button>
                </div>
              </el-form-item>

              <el-form-item label="短文内容" prop="title">
                <el-input type="textarea" id="insertAnswer" v-model="form.title" class="xtfl" rows="9" placeholder="请在此处输入填空题题型的题干，并点击“插入答案”按钮进行答案处的标注，并在习题答案处填入正确答案"></el-input>
                <div class="expansion">
                  <el-button @click="show=true" v-show="!show" type="primary">展开</el-button>
                </div>
                <div class="update">
                  <el-button v-if="imageUrl" @click="removeimage" type="primary" class="picture">删除图片</el-button>
                  <el-upload v-else action="#" :show-file-list="false" :http-request="handleAvatarSuccessImg">
                    <el-button size="small" type="primary">+ 上传图片</el-button>
                  </el-upload>
                  <div style="position:absolute; top:80px; width:100px; height:100px;" v-if="imageUrl">
                       <img :src="imageUrl" alt="" style="width:100%;">
                      </div>
                   <div class="insert_answer">
                  <el-button size="small" type="primary" round @click="insertAnswer()">插入答案</el-button>
                   </div>
                </div>
              </el-form-item>
              <el-form-item label="小题答案" prop="answerStr">
                <el-input type="textarea" v-model="form.answerStr" class="xtfl" rows="9" placeholder="请将题号和答案写在此处,题号与答案之间用:隔开，一行只能写一个题号。例如1:do"></el-input>
              </el-form-item>
              <el-form-item label="答案解析" prop="lookpicture">
                <el-input type="textarea" v-model="answerparse" class="xtfl" rows="9" placeholder="您可自由输入该习题的答案解析"></el-input>
              </el-form-item>
              <el-form-item label="难易程度" prop="radios">
                <el-radio-group v-model="form.radios">
                  <el-radio :label="1">易</el-radio>
                  <el-radio :label="2">中</el-radio>
                  <el-radio :label="3">难</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="知识点" prop="knowledge">
                <el-input type="textarea" v-model="points" class="xtfl" rows="9" placeholder="您可自行输入该题目所涉及到的知识点，可自由选择是否输入"></el-input>
              </el-form-item>
               <el-form-item class="tijiao">
                <el-button type="primary" @click="updateanswer()" v-if="edit" style="width:240px; height:46px; marginLeft:30px;">继续制题</el-button>
                <el-button type="primary" @click="editUpdate()" v-else style="width:240px; height:46px; marginLeft:30px;">保存编辑</el-button>
                <el-button style="width:240px; height:46px; marginLeft:30px;" v-show="edit" @click="comeBack=true">保存并返回</el-button>
                <div style="marginLeft:270px;" v-show="comeBack">
                  <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBackBig(1)">返回大题列表</el-button>
                  <div>
                      <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBacksmall(2)">返回小题列表</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
const axios = require('axios');
export default {
  data() {
    return {
      form: {
        title: '',
        answerStr:'',
         radios: '',
      },
       FormRules: {
        title: [
          { required: true, message: '请您填写必填信息',trigger: 'blur'}
        ],
        answerStr: [
          { required: true, message: '请您填写必填信息',trigger: 'blur'}
        ],
        
        radios: [
          { required: true, message: '请您填写必填信息',trigger: 'change'}
        ],
      },
      edit:true,
      comeBack:false,
      points:'',
      imageUrl:'',
      show:true,
      answerparse:'',
      insertList:['__'],
    };
  },
  created() {
    this.verdict();
  },

  methods: {
    verdict(){
      console.log(this.$route.query.questionId);
      if(this.$route.query.questionId === undefined){
        console.log(111);
      }else{
        this.findquestion();
        this.edit = false;
      }
    },
    //插入答案
   insertAnswer(){
       var elInput = document.getElementById('insertAnswer');
       var startPos = elInput.selectionStart;
       var endPos = elInput.selectionEnd;
       if (startPos === undefined || endPos === undefined) return
       var txt = elInput.value;
       var result = txt.substring(0, startPos) + this.insertList[0] + txt.substring(endPos)
       elInput.value = result;
       elInput.focus();
       elInput.selectionStart = startPos + this.insertList[0].length;
       elInput.selectionEnd = startPos + this.insertList[0].length;
      this.form.title = result;
        this.index++;
        if(this.index>20) {
          return this.$message.success('超出最大限制!')
        }
    },
    //删除图片
    removeimage(){
      this.imageUrl = '';
      this.$message.success('删除成功!');
    },
    //返回大题列表
    comeBackBig(big) {
      this.updateanswer(big);
    },
    comeBacksmall(big) {
      this.updateanswer(big);
    },
    //上传图片
   handleAvatarSuccessImg(data) {
      console.log(data.file)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.imageUrl = result.data.data;
            return this.$message.success('上传成功！');
          } 
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
       //查询题目
    findquestion(){
       let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/'+this.$route.query.questionId+'/essay/according-initial/fill-blanks',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res,'aaa');
          if (res.data.code === 0) {
            let data = res.data.data;
            this.form.title = data.text;
            this.imageUrl = data.img;
            this.suggestedAnswers = data.answerOpt;
            this.form.radios = data.level;
            this.form.answerStr = data.answerStr;
            this.answerparse = data.parse;
            this.points = data.points; 
          }
        })
    },
    //编辑提交
    editUpdate(){
      if(this.form.title.length>3070){
        return this.$message.warning("短文内容超过规定长度！")
      }
      if(this.form.answerStr.length>600){
        return this.$message.warning("答案超过规定长度！")
      }
       let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/'+this.$route.query.id+'/'+this.$route.query.questionId+'/essay/according-initial/fill-blanks/upd',
        method: 'POST',
        data: {
           img: this.imageUrl,
          level: this.form.radios,
          answerStr:this.form.answerStr,
          parse: this.answerparse,
          points: this.points,
          score: 0,
          text: this.form.title,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.$message.success('编辑成功！');
          // this.$router.go(-1);
        }
       else {
          this.$message.warning(res.data.message);
        }
      });
    },
      //提交答案
    updateanswer(big) {
      if(this.form.title.length>3070){
        return this.$message.warning("短文内容超过规定长度！")
      }
      if(this.form.answerStr.length>600){
        return this.$message.warning("答案超过规定长度！")
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/make/essay/according-initial/fill-blanks',
        method: 'POST',
        data: {
          attached: {
            bookId: Number(this.$route.query.bookid),
            section: this.$route.query.littleNode,
          },
          img: this.imageUrl,
          level: this.form.radios,
          pack: {
            number: this.$route.query.number,
            questionPackId: this.$route.query.id,
            score: 0,
          },
          answerStr:this.form.answerStr,
          parse: this.answerparse,
          points: this.points,
          score: 0,
          text: this.form.title,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          if(big === 1) {
            this.$router.go(-2);
          } else if (big===2) {
            this.$router.go(-1);
          }
          this.$message.success('提交成功！');
          this.index = 0;
          this.imageUrl = '';
          this.form.title ='';
          this.form.answerStr = '';
          this.form.radios = '';
          this.answerparse = '';
          this.points = '';
        }
         else{
          this.$message.error(res.data.message);
        }
      }).catch((err) => {
         if(big ==1||big==2){
             this.$confirm('必填信息出错，退出信息将被清空，确定退出?', '退出', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            console.log(111);
            if (big === 1) {
              this.$router.go(-2);
            } else if (big === 2) {
              this.$router.go(-1);
            }
          });
          }else {
            this.$message.error('制题失败:'+err)
          }
        });
    },
  },
};
</script>
<style lang="less">
.mains {
  box-sizing: border-box;
}
.el-card_body {
  position: relative;
}
.tishi {
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.form_1 {
  margin-top: 70px;
  margin-left: 273px;
}
.xiaoqu_1 {
  font-weight: 700;
}
.xtfl {
  width: 750px /* 750/16 */;
}
.xtfl1 {
  position: relative;
  width: 750px /* 750/16 */;
  height: auto /* 200/16 */;
  border: 1px solid #cccccc;
}
.xtfl1 button {
  position: absolute;
  top: 0;
  right: -100px;
}
.xtfl1 h3 {
  margin-top: 10px;
  margin-left: 10px;
}
.example {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: -20px;
}
.example span {
  display: inline-block;
  margin-right: 10px;
  font-size: 15px;
  color: #666666;
}
.example_img {
  margin-left: 1.875rem /* 30/16 */;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
}
.options {
  display: flex;
  width: 46.875rem /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
  margin-bottom: 20px;
}
.options_left {
  width: 130px;
  height: 100%;
  background-color: #cccccc;
  color: white;
  text-align: center;
}
.options_left p {
  font-size: 16px;
  margin-top: 70px;
}
.options_left_radio {
  color: #fff;
}
.addLable {
  width: 12.5rem /* 200/16 */;
  height: 2.25rem /* 36/16 */;
}
.btn_addlable {
  width: 6rem /* 96/16 */;
  height: 2.125rem /* 34/16 */;
  margin-left: 1.5625rem /* 25/16 */;
}
.el-textarea__inner {
  resize: none;
}
.insert_answer {
  position: absolute;
  bottom: -150px;
  right: 200px;
}
.score {
  display: flex;
}
.score > :nth-child(2) {
  margin: 0 110px 0 140px;
}
.grade {
  width: 6.25rem /* 100/16 */;
}
.tishi {
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.lookPicture {
  width: 750px;
  height: 110px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding-top: 10px;
}
.expansion {
  position: absolute;
  top: 0;
  right: 240px;
}
.addaudio {
  display: flex;
  width: 730px;
  height: 55px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding: 10px;
}
.replaceaudio {
  width: 100px /* 65/16 */;
  height: 42px;
  button {
    width: 100%;
    height: 100%;
    text-align: center;
  }
}
.update {
  position: absolute;
  display: flex;
  top: 0;
  right: 330px;
}

.upload-demo {
  margin-left: 30px;
}
.tijiao {
    margin-left: 100px;
}
</style>
